import LazyLoad from "vanilla-lazyload";

window.lazyLoader = new LazyLoad({
	class_loading: "lazy-loading"
});
